/**
 * Permission helpers: check if current user has a privilege (or is admin).
 * Use with Redux state.auth.user (user.permissions, user.role).
 */

export function hasPermission(user, privilege) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const permissions = user.permissions || [];
  return permissions.includes(privilege);
}

export function hasAnyPermission(user, privileges) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const userPermissions = user.permissions || [];
  return privileges.some((p) => userPermissions.includes(p));
}

export function isAdmin(user) {
  return user?.role === 'admin';
}
